import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import { _beginformState as _beginformStorage } from '../_states/_beginformState';

//Prevent browsing directly to later pages of the form without starting from the first page
export const UtrnValidation = () => {

    const navigate = useNavigate();

    useEffect(() => {
        const utrn = _beginformStorage.getUtrn();
        console.log("Checking UTRN: '"+utrn+"'" );
        if(!utrn || utrn.trim() === '') {
          console.log("Must start from first page so UTRN is populated, redirecting");
          navigate('/');
        }
      }, [navigate]);
}